/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import CmsContext from "../../../../../../context/CmsContext";
import * as actions from '../action';
import * as c from '../constant';
import BirthContent from './BirthContent';

const form = {
  keyword: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  module_type: 'PSA',
  transaction_type: 'BIRTH CERTIFICATE',
};

const statusFilters = [
  { label: 'ALL STATUS', value: '' },
  { label: 'FOR CHECKING', value: 'FOR CHECKING' },
  { label: 'WAITING FOR PAYMENT', value: 'WAITING FOR PAYMENT' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'FOR PRINTING', value: 'FOR PRINTING' },
  { label: 'FOR APPEARANCE', value: 'FOR APPEARANCE' },
  { label: 'FOR PICK-UP', value: 'FOR PICK-UP' },
  { label: 'REJECTED', value: 'REJECTED' },
  { label: 'PRINTED', value: 'PRINTED' },
  { label: 'RECEIVED', value: 'RECEIVED' },
  { label: 'EXPIRED REFERENCE NUMBER', value: 'EXPIRED REFERENCE NUMBER' },
]

function BirthContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  approveTransaction,
  showTransaction,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const UpdateData = () => {
    getTransactionList();
    return () => {
      setModal({ isOpen: false });
    };
  };

  const param = {
    module_type: 'PSA',
    transaction_type: 'BIRTH CERTIFICATE',
    q: formData.keyword,
    sort_by: 'asc',
    transaction_status: filter.transaction_status,
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      transaction_status: e.value,
      transaction_type: 'BIRTH CERTIFICATE',
    });
    getTransactionList({
      ...filter,
      transaction_status: e.value,
      transaction_type: 'BIRTH CERTIFICATE',
    });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getTransactionList({
        module_type: 'PSA',
        transaction_type: 'BIRTH CERTIFICATE',
        q: formData.keyword,
      });
    } else {
      getTransactionList({
        module_type: 'PSA',
        transaction_type: 'BIRTH CERTIFICATE',
      });
    }
  }, [debouncedSearchTerm]);

  const handleApprove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Approve this application?x',
      (remarks) => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'WAITING FOR PAYMENT',
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      (remarks) => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'FOR APPEARANCE',
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Applications"
            getData={getTransactionList}
            setParams={param}
            setKeyword={handleOnChange}
            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'transaction_status')
            )}
            status={_.get(filter, 'transaction_status') || ''}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            listName="Transaction"
            label="Transaction List"
            statusOptions={_.get(CMS_VARIABLES, "LGU_NAME") === "Cauayan" ? statusFilters : ''}
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {_.get(item, 'included.module.attributes.first_name')}{' '}
                  {_.get(item, 'included.module.attributes.middle_name')}{' '}
                  {_.get(item, 'included.module.attributes.extension_name') ||
                    ''}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'included.module.attributes.birth_date')
                    ? moment(
                        _.get(item, 'included.module.attributes.birth_date')
                      ).format('MM/DD/YYYY')
                    : '---'}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            statusFilter
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <BirthContent
                        UpdateData={UpdateData}
                        onApprove={handleApprove}
                        onReject={handleReject}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

BirthContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BirthContainer);
